{
  "version": 1,
  "asset_id": "717b3a17-005e-466b-92f4-4ed42613f924",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/717b3a17-005e-466b-92f4-4ed42613f924/how-monroya-works.png",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/717b3a17-005e-466b-92f4-4ed42613f924/how-monroya-works.png",
  "original_filename": "how-monroya-works.png",
  "size": 1637383,
  "content_type": "image/png",
  "created_at": "2026-08-18T22:15:32Z"
}
